<template>
    <nav class="navbar navbar-expand-md navbar-light">
        <a @click="goHome()" class="navbar-brand">
            <img :src="logoUrl" alt="Õhtuleht kirjastus" class="logo-width" v-if="logoUrl">
            <span v-else></span>
        </a>
        <button aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
                data-target="#navbarNav" data-toggle="collapse" type="button">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ml-auto">

                <li class="nav-item" v-bind:class="{ active: lang.code===store.locale }"
                    v-for="lang in languages">
                    <a @click.prevent="store.setLocale(lang.code)" class="nav-link language" href="#">{{lang.lang}}</a>
                </li>

            </ul>
        </div>
    </nav>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useMainStore } from '../includes/store';

const store = useMainStore();

const logoUrl = ref(null);

const languages = [
    {code: "et", "lang": "Eesti keel"},
    {code: "ru", "lang": "Русский язык"},
    {code: "en", "lang": "English"}
]

onMounted(() => {
    axios.get('logourl').then(response => {
        logoUrl.value = response.data.logoUrl;
    });
});

const goHome = () => {
    store.changeStep('intro');
}

</script>
